module.exports = __webpack_public_path__ + "static/media/package-crumbled-paper.49097bd5.png";